import { render, staticRenderFns } from "./IrisDisplayInputFieldSpecified.vue?vue&type=template&id=49caa2a6&"
import script from "./IrisDisplayInputFieldSpecified.vue?vue&type=script&lang=ts&"
export * from "./IrisDisplayInputFieldSpecified.vue?vue&type=script&lang=ts&"
import style0 from "./IrisDisplayInputFieldSpecified.vue?vue&type=style&index=0&id=49caa2a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports